<!-- 统一用户权限管理 - 用户管理 -->
<template>
    <div>
        <admin-main-header></admin-main-header>

        <div class="admin-main-body">
            <div
                class="admin-content"
                :style="{ minHeight: adminContentMinHeight + 'px' }"
            >
                <div class="admin-content-title el-clearfix">
                    <span class="el-title-bar"> 全部用户</span>
                    <span class="x-task-remark"
                        >可查询、修改全部用户，只能添加管理员用户，团队长和营销员的添加管理请移步"人员管理"模块</span
                    >
                </div>
                <div class="admin-content-main">
                    <div class="el-search-form">
                        <el-form ref="userQueryForm" :model="userQueryForm">
                            <el-row :gutter="20">
                                <el-col :span="4">
                                    <el-form-item prop="status">
                                        <el-select
                                            v-model="userQueryForm.vispRoleId"
                                            clearable
                                            placeholder="平台角色"
                                            class="el-full-width"
                                        >
                                            <el-option
                                                v-for="item in vispRoleList"
                                                :key="item.roleId"
                                                :label="item.roleName"
                                                :value="item.roleId"
                                            ></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="4">
                                    <el-form-item prop="userName">
                                        <el-input
                                            v-model="userQueryForm.userName"
                                            :maxlength="10"
                                            placeholder="用户名/姓名"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6">
                                    <el-form-item prop="orgId">
                                        <el-select
                                            v-model="userQueryForm.orgId"
                                            clearable
                                            filterable
                                            :filter-method="filterAllOrgs"
                                            @visible-change="
                                                resetOrgSelectFilterQuery
                                            "
                                            placeholder="所属组织机构"
                                            class="el-full-width"
                                        >
                                            <el-option
                                                v-for="item in userQueryOrgSelectOptions"
                                                :key="item.orgId"
                                                :label="item.orgName"
                                                :value="item.orgId"
                                                class="org-select-option"
                                            >
                                                <span class="option-left">{{
                                                    item.orgCode
                                                }}</span>
                                                <span class="option-right">{{
                                                    item.orgName
                                                }}</span>
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="4">
                                    <el-form-item prop="status">
                                        <el-select
                                            class="el-full-width"
                                            v-model="userQueryForm.status"
                                            placeholder="状态"
                                        >
                                            <el-option
                                                label="启用"
                                                :value="1"
                                            ></el-option>
                                            <el-option
                                                label="禁用"
                                                :value="0"
                                            ></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="5">
                                    <el-form-item class="el-align-center">
                                        <el-button
                                            @click="resetUserQueryForm"
                                            icon="fas fa-undo"
                                            >重 置</el-button
                                        >&nbsp;&nbsp;&nbsp;&nbsp;
                                        <el-button
                                            type="primary"
                                            @click="queryUserList(1000)"
                                            icon="fas fa-search"
                                            >查 询</el-button
                                        >
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </div>
                    <div class="el-search-toolbar">
                        <el-button
                            type="primary"
                            size="small"
                            icon="fas fa-plus-circle"
                            @click="openUserEditDialog('add')"
                            >添加用户</el-button
                        >
                    </div>
                    <div class="el-search-list">
                        <el-table
                            id="userTable"
                            v-loading="userQueryLoading"
                            element-loading-text="拼命加载中..."
                            element-loading-custom-class="el-loading-mask-opacity"
                            :class="{ loading: userQueryLoading }"
                            :data="userList"
                            :default-sort="userQuerySort"
                            @sort-change="onUserQuerySortChange"
                            style="width:100%;"
                            class="el-table-overflow-x-hidden"
                            empty-text="暂无数据"
                        >
                            <el-table-column
                                label="序号"
                                type="index"
                                width="50"
                                align="center"
                            ></el-table-column>
                            <el-table-column
                                label="登录账号"
                                prop="userName"
                                width="150"
                                sortable="custom"
                            >
                                <template slot-scope="scope">
                                    <div class="user-card">
                                        <img
                                            :src="scope.row.userIconUrl"
                                        /><span>{{ scope.row.userName }}</span>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="姓名"
                                prop="realName"
                                width="150"
                                align="center"
                                sortable="custom"
                            ></el-table-column>
                            <el-table-column
                                label="所属组织机构"
                                prop="orgName"
                                sortable="custom"
                            ></el-table-column>
                            <el-table-column
                                label="手机号码"
                                prop="mobilePhone"
                                width="110"
                                align="center"
                            ></el-table-column>
                            <el-table-column
                                label="邮箱"
                                prop="email"
                                width="200"
                                align="center"
                            ></el-table-column>
                            <el-table-column
                                label="用户状态"
                                prop="status"
                                width="100"
                                align="center"
                                sortable="custom"
                            >
                                <template slot-scope="scope">
                                    <el-switch
                                        slot="reference"
                                        v-model="scope.row.status"
                                        :title="
                                            getUserStatusTagName(
                                                scope.row.status
                                            )
                                        "
                                        active-color="#42A35A"
                                        inactive-color="#dcdfe6"
                                        :active-value="1"
                                        :inactive-value="0"
                                        @click.native="
                                            changeUserStatus(scope.row)
                                        "
                                    ></el-switch>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="创建时间"
                                prop="createTime"
                                width="100"
                                align="center"
                                sortable="custom"
                            ></el-table-column>
                            <el-table-column
                                label="操作"
                                width="140"
                                align="center"
                            >
                                <template slot-scope="scope">
                                    <el-button
                                        type="text"
                                        @click="
                                            openUserViewConfigDialog(
                                                'view',
                                                scope.row
                                            )
                                        "
                                        >查看详情</el-button
                                    >
                                    <el-dropdown
                                        size="small"
                                        trigger="click"
                                        @command="
                                            handleUserCommand(
                                                arguments[0],
                                                scope.row
                                            )
                                        "
                                    >
                                        <span class="el-dropdown-link">
                                            <i
                                                class="el-icon-arrow-down el-icon--right"
                                            ></i>
                                        </span>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item command="view"
                                                >查看详情</el-dropdown-item
                                            >
                                            <el-dropdown-item command="edit"
                                                >修改用户</el-dropdown-item
                                            >
                                            <el-dropdown-item
                                                command="changepwd"
                                                >修改密码</el-dropdown-item
                                            >
                                            <el-dropdown-item command="config"
                                                >配置角色</el-dropdown-item
                                            >
                                            <el-dropdown-item
                                                command="delete"
                                                divided
                                                >删除用户</el-dropdown-item
                                            >
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="el-search-pager">
                        <el-pagination
                            background
                            v-show="showUserQueryPager"
                            @current-change="onUserQueryCurrentPageChange"
                            :current-page.sync="userQueryForm.currentPage"
                            :page-size="userQueryForm.pageSize"
                            layout="slot, prev, pager, next, total"
                            :total="userQueryTotal"
                        >
                            <div class="el-pagination-pagesize">
                                <span class="first">每页显示</span>
                                <el-button-group>
                                    <el-button
                                        :class="{
                                            active: userQueryForm.pageSize == 10
                                        }"
                                        @click="onUserQueryPageSizeChange(10)"
                                        >10</el-button
                                    >
                                    <el-button
                                        :class="{
                                            active: userQueryForm.pageSize == 20
                                        }"
                                        @click="onUserQueryPageSizeChange(20)"
                                        >20</el-button
                                    >
                                    <el-button
                                        :class="{
                                            active: userQueryForm.pageSize == 50
                                        }"
                                        @click="onUserQueryPageSizeChange(50)"
                                        >50</el-button
                                    >
                                    <el-button
                                        :class="{
                                            active:
                                                userQueryForm.pageSize == 100
                                        }"
                                        @click="onUserQueryPageSizeChange(100)"
                                        >100</el-button
                                    >
                                </el-button-group>
                                <span class="last">条</span>
                            </div>
                        </el-pagination>
                    </div>

                    <!-- 添加/修改Dialog -->
                    <el-drawer
                        size="70%"
                        :visible.sync="userEditDialogVisible"
                        @closed="closeUserEditDialog"
                    >
                        <span slot="title" class="el-drawer-title">
                            {{ userEditDialogTitle }}</span
                        >
                        <div class="el-drawer-content">
                            <el-form
                                class="el-drawer-content-body"
                                v-custom-validator-apply="userEditRules"
                                ref="userEditForm"
                                :model="userEditForm"
                                :rules="userEditRules"
                                label-width="120px"
                            >
                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="用户名"
                                            prop="userName"
                                        >
                                            <el-col :span="12">
                                                <el-input
                                                    v-model="
                                                        userEditForm.userName
                                                    "
                                                    :maxlength="20"
                                                    autocomplete="off"
                                                ></el-input>
                                            </el-col>
                                            <el-col :span="12">
                                                <p class="el-form-item-tips">
                                                    由字母开头,5~20个字母、数字及下划线组成.
                                                </p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="姓 名"
                                            prop="realName"
                                        >
                                            <el-col :span="12">
                                                <el-input
                                                    v-model="
                                                        userEditForm.realName
                                                    "
                                                    :maxlength="32"
                                                ></el-input>
                                            </el-col>
                                            <el-col :span="12">
                                                <p class="el-form-item-tips">
                                                    真实姓名.
                                                </p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row v-if="currentActionType == 'add'">
                                    <el-col :span="12">
                                        <el-form-item
                                            label="账户密码"
                                            prop="password"
                                        >
                                            <el-col :span="12">
                                                <el-input
                                                    v-model="
                                                        userEditForm.password
                                                    "
                                                    :maxlength="20"
                                                    type="password"
                                                    autocomplete="new-password"
                                                ></el-input>
                                            </el-col>
                                            <el-col :span="12">
                                                <p class="el-form-item-tips">
                                                    由6~20位个字母或数字组成.
                                                </p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="重复密码"
                                            prop="repassword"
                                        >
                                            <el-col :span="12">
                                                <el-input
                                                    v-model="
                                                        userEditForm.repassword
                                                    "
                                                    :maxlength="20"
                                                    type="password"
                                                    autocomplete="new-password"
                                                ></el-input>
                                            </el-col>
                                            <el-col :span="12">
                                                <p class="el-form-item-tips">
                                                    请再次确认您输入的密码.
                                                </p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="手机号码"
                                            prop="mobilePhone"
                                        >
                                            <el-col :span="12">
                                                <el-input
                                                    v-model="
                                                        userEditForm.mobilePhone
                                                    "
                                                    :maxlength="11"
                                                ></el-input>
                                            </el-col>
                                            <el-col :span="12">
                                                <p
                                                    class="el-form-item-tips"
                                                ></p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="EMAIL"
                                            prop="email"
                                        >
                                            <el-col :span="12">
                                                <el-input
                                                    v-model="userEditForm.email"
                                                    :maxlength="100"
                                                ></el-input>
                                            </el-col>
                                            <el-col :span="12">
                                                <p
                                                    class="el-form-item-tips"
                                                ></p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="所属组织机构"
                                            prop="orgId"
                                        >
                                            <el-col :span="24">
                                                <el-select
                                                    v-model="userEditForm.orgId"
                                                    filterable
                                                    :filter-method="
                                                        filterAllOrgs
                                                    "
                                                    @visible-change="
                                                        resetOrgSelectFilterQuery
                                                    "
                                                    class="el-full-width"
                                                >
                                                    <el-option
                                                        v-for="item in userEditOrgSelectOptions"
                                                        :key="item.orgId"
                                                        :label="item.orgName"
                                                        :value="item.orgId"
                                                        class="org-select-option"
                                                    >
                                                        <span
                                                            class="option-left"
                                                            >{{
                                                                item.orgCode
                                                            }}</span
                                                        >
                                                        <span
                                                            class="option-right"
                                                            >{{
                                                                item.orgName
                                                            }}</span
                                                        >
                                                    </el-option>
                                                </el-select>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row v-if="currentActionType == 'add'">
                                    <el-col :span="12">
                                        <el-form-item
                                            label="所属平台角色"
                                            prop="vispRoleId"
                                        >
                                            <el-col :span="24">
                                                <el-select
                                                    v-model="
                                                        userEditForm.vispRoleId
                                                    "
                                                    clearable
                                                    class="el-full-width"
                                                >
                                                    <el-option
                                                        v-for="item in editVispRoleList"
                                                        :key="item.roleId"
                                                        :label="item.roleName"
                                                        :value="item.roleId"
                                                    ></el-option>
                                                </el-select>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <p
                                            class="el-form-item-tips"
                                            style="line-height:40px;"
                                        >
                                            此处只能是公司管理员，团队长、营销员的管理请移步'人员管理'模块
                                        </p>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item
                                            label="上传头像"
                                            prop="userIcon"
                                        >
                                            <el-col :span="24">
                                                <el-upload
                                                    class="el-upload-plus-uploader user-avatar-uploader"
                                                    :headers="uploadHeaders"
                                                    :action="userIconUploadUrl"
                                                    :data="userIconUploadParam"
                                                    :show-file-list="false"
                                                    :before-upload="
                                                        beforeUserIconUpload
                                                    "
                                                    :on-remove="
                                                        handleUserIconRemove
                                                    "
                                                    :on-success="
                                                        handleUserIconUploadSuccess
                                                    "
                                                    :on-error="
                                                        handleUploadError
                                                    "
                                                >
                                                    <img
                                                        class="user-avatar"
                                                        v-if="
                                                            userEditForm.userIcon
                                                        "
                                                        :src="
                                                            userEditForm.userIconUrl
                                                        "
                                                        title="点击原图片可以重新上传新图片!"
                                                    />
                                                    <i
                                                        v-else
                                                        class="el-icon-plus el-upload-plus-trigger"
                                                    ></i>
                                                    <div
                                                        class="el-upload__tip"
                                                        slot="tip"
                                                    >
                                                        只能上传jpg|png文件，大小不超过50kb，图片像素限90x90像素附近(长宽误差不超过10个像素)，点击原图片可以重新上传新图片!
                                                    </div>
                                                </el-upload>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                            <div class="el-drawer-content-footer">
                                <el-button
                                    icon="fas fa-ban"
                                    @click="closeUserEditDialog"
                                    >取 消</el-button
                                >
                                <el-button
                                    type="primary"
                                    icon="far fa-save"
                                    @click="saveUser"
                                    :loading="submiting"
                                    >确 定</el-button
                                >
                            </div>
                        </div>
                    </el-drawer>

                    <!-- 查看/配置Dialog -->
                    <el-drawer
                        size="70%"
                        :visible.sync="userViewConfigDialogVisible"
                        @closed="closeUserViewConfigDialog"
                    >
                        <span slot="title" class="el-drawer-title">
                            {{ userViewConfigDialogTitle }}</span
                        >
                        <div class="el-drawer-content">
                            <el-tabs
                                class="el-drawer-content-body"
                                v-model="userViewConfigActiveTabName"
                            >
                                <el-tab-pane
                                    label="用户基本信息"
                                    name="userDetail"
                                >
                                    <el-form
                                        class="el-form-detail"
                                        inline
                                        label-position="right"
                                        label-width="120px"
                                        label-suffix="："
                                    >
                                        <el-form-item label="用户ID">{{
                                            userViewForm.userId
                                        }}</el-form-item>
                                        <el-form-item label="用户名">
                                            <div class="user-card">
                                                <img
                                                    :src="
                                                        userViewForm.userIconUrl
                                                    "
                                                /><span>{{
                                                    userViewForm.userName
                                                }}</span>
                                            </div>
                                        </el-form-item>

                                        <el-form-item label="昵  称">{{
                                            userViewForm.nickName
                                        }}</el-form-item>
                                        <el-form-item label="姓  名">{{
                                            userViewForm.realName
                                        }}</el-form-item>

                                        <el-form-item label="手机号码">{{
                                            userViewForm.mobilePhone
                                        }}</el-form-item>
                                        <el-form-item label="EMAIL">{{
                                            userViewForm.email
                                        }}</el-form-item>

                                        <el-form-item label="用户类型">
                                            <el-tag
                                                size="small"
                                                :type="
                                                    getUserTypeTagType(
                                                        userViewForm.userType
                                                    )
                                                "
                                                >{{
                                                    userViewForm.userTypeName
                                                }}</el-tag
                                            >
                                        </el-form-item>
                                        <el-form-item label="状  态">
                                            <el-tag
                                                size="small"
                                                :type="
                                                    getUserStatusTagType(
                                                        userViewForm.status
                                                    )
                                                "
                                                >{{
                                                    userViewForm.statusName
                                                }}</el-tag
                                            >
                                        </el-form-item>

                                        <el-form-item
                                            label="所属组织机构"
                                            style="width:100%;"
                                        >
                                            <el-tag
                                                size="small"
                                                type="primary"
                                                >{{
                                                    userViewForm.orgName
                                                }}</el-tag
                                            >
                                        </el-form-item>

                                        <el-form-item label="最后登录时间">{{
                                            userViewForm.lastLoginTime
                                        }}</el-form-item>
                                        <el-form-item label="登录总次数">{{
                                            userViewForm.loginTimes
                                        }}</el-form-item>

                                        <el-form-item label="创建时间">{{
                                            userViewForm.createTime
                                        }}</el-form-item>
                                        <el-form-item label="修改时间">{{
                                            userViewForm.updateTime
                                        }}</el-form-item>
                                    </el-form>
                                </el-tab-pane>
                                <el-tab-pane
                                    label="用户角色列表"
                                    name="userRoleConfig"
                                >
                                    <el-form
                                        ref="userRoleQueryForm"
                                        :model="userRoleQueryForm"
                                        style="padding: 5px 0 0;"
                                    >
                                        <el-row :gutter="20">
                                            <el-col :span="5" :offset="2">
                                                <el-form-item prop="roleName">
                                                    <el-input
                                                        v-model="
                                                            userRoleQueryForm.roleName
                                                        "
                                                        :maxlength="100"
                                                        placeholder="角色名称"
                                                    ></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="5">
                                                <el-form-item prop="roleCode">
                                                    <el-input
                                                        v-model="
                                                            userRoleQueryForm.roleCode
                                                        "
                                                        :maxlength="100"
                                                        placeholder="角色代码"
                                                    ></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="5">
                                                <el-form-item
                                                    class="el-align-center"
                                                >
                                                    <el-button
                                                        @click="
                                                            resetUserRoleQueryForm
                                                        "
                                                        icon="fas fa-undo"
                                                        >重 置</el-button
                                                    >&nbsp;&nbsp;&nbsp;&nbsp;
                                                    <el-button
                                                        type="primary"
                                                        @click="
                                                            queryUserRoleList(
                                                                1000
                                                            )
                                                        "
                                                        icon="fas fa-search"
                                                        >查 询</el-button
                                                    >
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="7">
                                                <el-form-item
                                                    v-if="
                                                        currentActionType ==
                                                            'config'
                                                    "
                                                    class="el-align-right"
                                                >
                                                    <el-button
                                                        type="primary"
                                                        icon="fas fa-plus-circle"
                                                        @click="
                                                            showUserRoleAddTab
                                                        "
                                                        >添加用户角色</el-button
                                                    >
                                                    <el-button
                                                        type="primary"
                                                        icon="fas fa-minus-circle"
                                                        :loading="submiting"
                                                        @click="
                                                            delUserRoleConfig
                                                        "
                                                        >移除选中角色</el-button
                                                    >
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-form>
                                    <el-table
                                        ref="userRoleTable"
                                        class="el-table-maxheight-fix"
                                        v-loading="userRoleQueryLoading"
                                        element-loading-text="拼命加载中..."
                                        element-loading-custom-class="el-loading-mask-opacity"
                                        :class="{
                                            loading: userRoleQueryLoading
                                        }"
                                        :data="userRoleList"
                                        max-height="320"
                                        style="width:100%;"
                                        @selection-change="
                                            onUserRoleSelectionChange
                                        "
                                        empty-text="暂无配置"
                                    >
                                        <el-table-column
                                            label="#"
                                            type="index"
                                            width="40"
                                        ></el-table-column>
                                        <el-table-column
                                            type="selection"
                                            width="60"
                                            v-if="currentActionType == 'config'"
                                        ></el-table-column>
                                        <el-table-column
                                            label="角色名称"
                                            prop="roleName"
                                            width="170"
                                        ></el-table-column>
                                        <el-table-column
                                            label="角色代码"
                                            prop="roleCode"
                                            width="170"
                                        ></el-table-column>
                                        <el-table-column
                                            label="角色类型"
                                            prop="roleType"
                                            width="120"
                                            align="center"
                                        >
                                            <template slot-scope="scope">
                                                <el-tag
                                                    size="small"
                                                    :type="
                                                        getRoleTypeTagType(
                                                            scope.row.roleType
                                                        )
                                                    "
                                                    >{{
                                                        scope.row.roleTypeName
                                                    }}</el-tag
                                                >
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            label="角色描述"
                                            prop="description"
                                        ></el-table-column>
                                        <el-table-column
                                            label="配置时间"
                                            prop="createTime"
                                            width="100"
                                            align="center"
                                        ></el-table-column>
                                    </el-table>
                                </el-tab-pane>
                                <el-tab-pane
                                    v-if="currentActionType == 'config'"
                                    label="添加用户角色"
                                    name="userRoleAdd"
                                >
                                    <el-form
                                        ref="roleQueryForm"
                                        :model="roleQueryForm"
                                        style="padding: 5px 0 0;"
                                    >
                                        <el-row :gutter="20">
                                            <el-col :span="4">
                                                <el-form-item prop="roleName">
                                                    <el-input
                                                        v-model="
                                                            roleQueryForm.roleName
                                                        "
                                                        :maxlength="100"
                                                        placeholder="角色名称"
                                                    ></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="4">
                                                <el-form-item prop="roleCode">
                                                    <el-input
                                                        v-model="
                                                            roleQueryForm.roleCode
                                                        "
                                                        :maxlength="100"
                                                        placeholder="角色代码"
                                                    ></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="5">
                                                <el-form-item
                                                    class="el-align-center"
                                                >
                                                    <el-button
                                                        @click="
                                                            resetRoleQueryForm
                                                        "
                                                        icon="fas fa-undo"
                                                        >重 置</el-button
                                                    >&nbsp;&nbsp;&nbsp;&nbsp;
                                                    <el-button
                                                        type="primary"
                                                        @click="
                                                            queryRoleList(1000)
                                                        "
                                                        icon="fas fa-search"
                                                        >查 询</el-button
                                                    >
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="7">
                                                <el-form-item
                                                    class="el-align-right"
                                                >
                                                    <el-button
                                                        type="primary"
                                                        icon="fas fa-plus-circle"
                                                        :loading="submiting"
                                                        @click="
                                                            addUserRoleConfig
                                                        "
                                                        >添加选中角色</el-button
                                                    >
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-form>
                                    <el-table
                                        ref="roleTable"
                                        class="el-table-maxheight-fix"
                                        v-loading="roleQueryLoading"
                                        element-loading-text="拼命加载中..."
                                        element-loading-custom-class="el-loading-mask-opacity"
                                        :class="{ loading: roleQueryLoading }"
                                        :data="roleList"
                                        max-height="320"
                                        style="width:100%;"
                                        @selection-change="
                                            onRoleSelectionChange
                                        "
                                        empty-text="暂无数据"
                                    >
                                        <el-table-column
                                            label="#"
                                            type="index"
                                            width="40"
                                        ></el-table-column>
                                        <el-table-column
                                            type="selection"
                                            width="60"
                                            v-if="currentActionType == 'config'"
                                        ></el-table-column>
                                        <el-table-column
                                            label="角色名称"
                                            prop="roleName"
                                            width="170"
                                            sortable
                                        ></el-table-column>
                                        <el-table-column
                                            label="角色代码"
                                            prop="roleCode"
                                            width="170"
                                            sortable
                                        ></el-table-column>
                                        <el-table-column
                                            label="角色类型"
                                            prop="roleType"
                                            width="120"
                                            align="center"
                                            sortable
                                        >
                                            <template slot-scope="scope">
                                                <el-tag
                                                    size="small"
                                                    :type="
                                                        getRoleTypeTagType(
                                                            scope.row.roleType
                                                        )
                                                    "
                                                    >{{
                                                        scope.row.roleTypeName
                                                    }}</el-tag
                                                >
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            label="角色描述"
                                            prop="description"
                                        ></el-table-column>
                                        <el-table-column
                                            label="创建时间"
                                            prop="createTime"
                                            width="100"
                                            align="center"
                                            sortable
                                        ></el-table-column>
                                    </el-table>
                                    <div class="el-search-pager">
                                        <el-pagination
                                            background
                                            v-show="showRoleQueryPager"
                                            @current-change="
                                                onRoleQueryCurrentPageChange
                                            "
                                            :current-page="
                                                roleQueryForm.currentPage
                                            "
                                            :page-size="roleQueryForm.pageSize"
                                            layout="prev, pager, next, total"
                                            :total="roleQueryTotal"
                                        >
                                        </el-pagination>
                                    </div>
                                </el-tab-pane>
                            </el-tabs>
                            <div class="el-drawer-content-footer">
                                <el-button
                                    icon="fas fa-ban"
                                    @click="closeUserViewConfigDialog"
                                    >关 闭</el-button
                                >
                            </div>
                        </div>
                    </el-drawer>

                    <!-- 修改用户密码Dialog -->
                    <el-drawer
                        size="70%"
                        :visible.sync="changeUserPwdDialogVisible"
                        @closed="closeChangeUserPwdDialog"
                    >
                        <span slot="title" class="el-drawer-title">
                            修改用户密码</span
                        >
                        <div class="el-drawer-content">
                            <el-form
                                class="el-drawer-content-body"
                                v-custom-validator-apply="changeUserPwdRules"
                                ref="changeUserPwdForm"
                                :model="changeUserPwdForm"
                                :rules="changeUserPwdRules"
                                label-width="220px"
                            >
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item
                                            label="用户名"
                                            prop="userName"
                                        >
                                            <el-col :span="14">
                                                <span
                                                    style="line-height:32px;font-weight:bold;color:#000;"
                                                    >{{
                                                        changeUserPwdForm.userName
                                                    }}</span
                                                >
                                            </el-col>
                                            <el-col :span="10"> </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item
                                            label="账户密码"
                                            prop="password"
                                        >
                                            <el-col :span="14">
                                                <el-input
                                                    v-model="
                                                        changeUserPwdForm.password
                                                    "
                                                    :maxlength="20"
                                                    type="password"
                                                    autocomplete="new-password"
                                                ></el-input>
                                            </el-col>
                                            <el-col :span="10">
                                                <p class="el-form-item-tips">
                                                    由6~20位个字母或数字组成.
                                                </p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item
                                            label="重复密码"
                                            prop="repassword"
                                        >
                                            <el-col :span="14">
                                                <el-input
                                                    v-model="
                                                        changeUserPwdForm.repassword
                                                    "
                                                    :maxlength="20"
                                                    type="password"
                                                    autocomplete="new-password"
                                                ></el-input>
                                            </el-col>
                                            <el-col :span="10">
                                                <p class="el-form-item-tips">
                                                    请再次确认您输入的密码.
                                                </p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                            <div class="el-drawer-content-footer">
                                <el-button
                                    icon="fas fa-ban"
                                    @click="closeChangeUserPwdDialog"
                                    >取 消</el-button
                                >
                                <el-button
                                    type="primary"
                                    icon="far fa-save"
                                    @click="changeUserPassword"
                                    :loading="submiting"
                                    >确 定</el-button
                                >
                            </div>
                        </div>
                    </el-drawer>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { defaultApiErrorHandler, PLATFORM_API } from '@/api.js';
import { COMMON_PATTERNS, mapSort } from '@/utils.js';
import { CustomValidator } from '@/plugins';

const UPMS_USER_TYPE_SYSTEM = 0;
const IMAGE_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];
const UPMS_USER_STATUS = {
    1: '启用',
    0: '禁用'
};
const ALL_VISP_ROLE_CODES = [
    'sysadmin',
    'comadmin',
    'teamleader',
    'salesman',
    'guest'
];
//用户新增/修改时能选择的角色(不包括团队长、营销员，他们俩的管理由单独的人员管理模块来负责)
const EDIT_VISP_ROLE_CODES = ['comadmin', 'guest'];

export default {
    name: 'UpmsUser',
    data() {
        return {
            submiting: false,
            userQueryForm: {
                userName: '',
                vispRoleId: '',
                orgId: '',
                userType: '',
                status: '',
                pageSize: 10,
                currentPage: 1
            },
            userQuerySort: {
                prop: 'createTime',
                order: 'descending'
            },
            userQueryLoading: false,
            userQuering: false,
            userQueryTotal: 0,
            userList: [],
            currentActionType: 'add',
            userEditDialogVisible: false,
            userViewConfigDialogVisible: false,
            userViewConfigActiveTabName: 'userDetail',
            userIconUploadUrl: PLATFORM_API.of('/api/xupload/public/image'),
            userIconUploadParam: {
                formatLimit: 'jpeg,jpg,png',
                pixelLimit: '90x90'
            },
            userEditForm: {
                userId: '',
                userName: '',
                password: '',
                repassword: '',
                realName: '',
                mobilePhone: '',
                email: '',
                userIcon: '',
                userIconUrl: '',
                orgId: '',
                vispRoleId: ''
            },
            userEditRules: {
                userName: [
                    {
                        required: true,
                        message: '请输入用户名!'
                    },
                    {
                        pattern: /^[a-zA-Z0-9_]{2,20}$/,
                        message:
                            '用户名必须由字母开头,3~20个字母、数字及下划线组成!'
                    }
                ],
                password: [
                    {
                        required: true,
                        message: '请输入账户密码!'
                    },
                    {
                        pattern: /^[a-zA-Z0-9]{6,20}$/,
                        message: '账户密码由6~20个字母或数字组成!'
                    }
                ],
                repassword: [
                    {
                        required: true,
                        message: '请再次输入账户密码!'
                    },
                    {
                        pattern: /^[a-zA-Z0-9]{6,20}$/,
                        message: '账户密码由6~20个字母或数字组成!'
                    },
                    {
                        validator: CustomValidator.equalTo,
                        compareTarget: {
                            form: 'userEditForm',
                            field: 'password'
                        },
                        message: '两次密码输入不一致!'
                    }
                ],
                realName: [
                    {
                        required: true,
                        message: '请输入姓名!'
                    },
                    {
                        pattern: /^[a-zA-Z\u00a1-\uffff0-9_]{2,50}$/,
                        message: '角色名称由2~50个汉字、字母、数字及下划线组成!'
                    }
                ],
                mobilePhone: [
                    {
                        pattern: COMMON_PATTERNS.MOBILE,
                        message: '手机号码不合法!'
                    }
                ],
                email: [
                    {
                        type: 'email',
                        message: 'EMAIL不合法!'
                    }
                ],
                orgId: [
                    {
                        type: 'integer',
                        required: true,
                        message: '请选择一个所属组织机构!'
                    }
                ],
                vispRoleId: [
                    {
                        type: 'integer',
                        required: true,
                        message: '请选择一个平台角色!'
                    }
                ]
            },
            userViewForm: {
                userId: '',
                userName: '',
                nickName: '',
                realName: '',
                mobilePhone: '',
                email: '',
                userIcon: '',
                userIconUrl: '',
                status: '',
                statusName: '',
                userType: '',
                userTypeName: '',
                createBy: '',
                createTime: '',
                updateBy: '',
                updateTime: '',
                lastLoginTime: '',
                loginTimes: '',
                orgName: ''
            },
            changeUserPwdForm: {
                userId: '',
                userName: '',
                password: '',
                repassword: ''
            },
            changeUserPwdRules: {
                password: [
                    {
                        required: true,
                        message: '请输入账户密码!'
                    },
                    {
                        pattern: /^[a-zA-Z0-9]{6,20}$/,
                        message: '账户密码由6~20个字母或数字组成!'
                    }
                ],
                repassword: [
                    {
                        required: true,
                        message: '请再次输入账户密码!'
                    },
                    {
                        pattern: /^[a-zA-Z0-9]{6,20}$/,
                        message: '账户密码由6~20个字母或数字组成!'
                    },
                    {
                        validator: CustomValidator.equalTo,
                        compareTarget: {
                            form: 'changeUserPwdForm',
                            field: 'password'
                        },
                        message: '两次密码输入不一致!'
                    }
                ]
            },
            changeUserPwdDialogVisible: false,
            userRoleList: [],
            userRoleQueryLoading: false,
            roleList: [],
            roleQueryLoading: false,
            addSelectedRoleIds: [],
            delSelectedRoleIds: [],
            roleQuering: false,
            userRoleQueryForm: {
                roleName: '',
                roleCode: ''
            },
            roleQueryForm: {
                roleName: '',
                roleCode: '',
                pageSize: 10,
                currentPage: 1,
                orders: 'createTime:desc'
            },
            roleQueryTotal: 0,
            vispRoleList: [],
            allOrgList: [],
            orgSelectFilterQuery: ''
        };
    },
    computed: {
        userEditOrgSelectOptions() {
            if (this.orgSelectFilterQuery) {
                return this.allOrgList.filter(org => {
                    if (org.orgCode.indexOf(this.orgSelectFilterQuery) > -1) {
                        return true;
                    }
                    if (org.orgName.indexOf(this.orgSelectFilterQuery) > -1) {
                        return true;
                    }
                    return false;
                });
            } else {
                let allOrgs = this.allOrgList.filter(org => true);
                //allOrgs.unshift({ orgId: 0, orgName: '全部', orgCode: 'ALL' });
                return allOrgs;
            }
        },
        userQueryOrgSelectOptions() {
            if (this.orgSelectFilterQuery) {
                return this.allOrgList.filter(org => {
                    if (org.orgCode.indexOf(this.orgSelectFilterQuery) > -1) {
                        return true;
                    }
                    if (org.orgName.indexOf(this.orgSelectFilterQuery) > -1) {
                        return true;
                    }
                    return false;
                });
            } else {
                return this.allOrgList.filter(org => true);
            }
        },
        uploadHeaders() {
            let headers = {
                Accept: 'application/json'
            };
            let accessToken = this.$store.getters.getAccessToken();
            if (accessToken && accessToken.access_token) {
                headers['Authorization'] = 'bearer ' + accessToken.access_token;
            }
            return headers;
        },
        showUserQueryPager() {
            if (this.userQuering || this.userQueryTotal == 0) {
                return false;
            } else {
                return true;
            }
        },
        showRoleQueryPager() {
            if (this.roleQuering || this.roleQueryTotal == 0) {
                return false;
            } else {
                return true;
            }
        },
        userEditDialogTitle() {
            if (this.currentActionType == 'add') {
                return '添加用户';
            } else if (this.currentActionType == 'edit') {
                return '修改用户';
            } else {
                return '';
            }
        },
        userViewConfigDialogTitle() {
            if (this.currentActionType == 'view') {
                return '查看用户详情';
            } else if (this.currentActionType == 'config') {
                return '用户角色配置';
            } else {
                return '';
            }
        },
        editVispRoleList() {
            return this.vispRoleList.filter(role => {
                return EDIT_VISP_ROLE_CODES.includes(role.roleCode);
            });
        }
    },
    created() {
        this.loadAllOrgList();
        this.loadVispRoleList();
    },
    mounted() {
        this.queryUserList(1000);
    },
    methods: {
        getUserTypeTagType(userType) {
            if (userType == 0) {
                return 'success';
            } else {
                return 'primary';
            }
        },
        getOnlineStatusTagName(online) {
            if (online) {
                return '在线';
            } else {
                return '离线';
            }
        },
        getUserStatusTagName(status) {
            return UPMS_USER_STATUS[status];
        },
        getUserStatusTagType(status) {
            if (status == 0) {
                return 'danger';
            } else {
                return 'success';
            }
        },
        getRoleTypeTagType(roleType) {
            if (roleType == 0) {
                return 'success';
            } else {
                return 'primary';
            }
        },
        filterAllOrgs(value) {
            this.orgSelectFilterQuery = value;
        },
        loadAllOrgList() {
            let url = PLATFORM_API.of('/api/platform/upms/org/all');
            this.$http
                .get(url)
                .then(response => {
                    let result = response.data;
                    if (result.success) {
                        this.allOrgList = result.data;
                    }
                })
                .catch(defaultApiErrorHandler);
        },
        loadVispRoleList() {
            let url = PLATFORM_API.of('/api/platform/visp/role/list');
            this.$http
                .get(url, {
                    params: { codes: ALL_VISP_ROLE_CODES.join(',') }
                })
                .then(response => {
                    let result = response.data;
                    if (result.success) {
                        this.vispRoleList = result.data;
                    }
                })
                .catch(defaultApiErrorHandler);
        },
        queryUserList(loading) {
            this.userQueryForm.currentPage = 1;
            this.doQueryUserList(loading);
        },
        doQueryUserList(loading) {
            this.userQuering = true;
            if (loading) {
                this.userQueryLoading = true;
            }
            setTimeout(() => {
                let params = Object.assign(
                    {},
                    this.userQueryForm,
                    mapSort(this.userQuerySort)
                );
                this.$http
                    .get(PLATFORM_API.of('/api/platform/upms/user/list'), {
                        params: params
                    })
                    .then(response => {
                        let result = response.data;
                        if (result.success) {
                            this.userList = result.data;
                            this.userQueryTotal = result.totalRowCount;
                        } else {
                            this.userList = [];
                            this.userQueryTotal = 0;
                            this.$message.error(result.message);
                        }
                    })
                    .catch(error => {
                        this.userList = [];
                        this.userQueryTotal = 0;
                        defaultApiErrorHandler.call(this, error);
                    })
                    .then(() => {
                        if (loading) {
                            this.userQueryLoading = false;
                        }
                        this.userQuering = false;
                    });
            }, loading);
        },
        resetUserQueryForm() {
            this.$refs.userQueryForm.resetFields();
        },
        onUserQuerySortChange(parameter) {
            if (
                this.userQuerySort.prop != parameter.prop ||
                this.userQuerySort.order != parameter.order
            ) {
                this.userQuerySort.prop = parameter.prop;
                this.userQuerySort.order = parameter.order;
                this.queryUserList(1000);
            }
        },
        onUserQueryPageSizeChange(pageSize) {
            this.userQueryForm.pageSize = pageSize;
            this.queryUserList(1000);
        },
        onUserQueryCurrentPageChange(currentPage) {
            this.userQueryForm.currentPage = currentPage;
            this.doQueryUserList(1000);
        },
        handleUserCommand(cmd, row) {
            if (cmd == 'edit') {
                this.openUserEditDialog(cmd, row);
            } else if (cmd == 'view') {
                this.openUserViewConfigDialog(cmd, row);
            } else if (cmd == 'delete') {
                this.deleteUser(row);
            } else if (cmd == 'config') {
                this.openUserViewConfigDialog(cmd, row);
            } else if (cmd == 'changepwd') {
                this.openChangeUserPwdDialog(cmd, row);
            }
        },
        openUserEditDialog(cmd, row) {
            this.currentActionType = cmd;
            this.userEditDialogVisible = true;
            if (cmd == 'edit') {
                Vue.nextTick(() => {
                    Object.keys(this.userEditForm).forEach(name => {
                        this.userEditForm[name] = row[name];
                    });
                });
            }
        },
        closeUserEditDialog() {
            this.submiting = false;
            this.userEditDialogVisible = false;
            this.$refs.userEditForm.resetFields();
            this.userEditForm.userId = ''; //手动reset
        },
        openUserViewConfigDialog(cmd, row) {
            this.currentActionType = cmd;
            this.userViewConfigDialogVisible = true;
            Vue.nextTick(() => {
                Object.keys(this.userViewForm).forEach(name => {
                    this.userViewForm[name] = row[name];
                });
                if (cmd == 'config') {
                    this.userViewConfigActiveTabName = 'userRoleConfig';
                    Vue.nextTick(() => {
                        this.queryUserRoleList(1000);
                    });
                } else {
                    this.userViewConfigActiveTabName = 'userDetail';
                    this.queryUserRoleList(0);
                }
            });
        },
        closeUserViewConfigDialog() {
            this.userViewConfigDialogVisible = false;
            Object.keys(this.userViewForm).forEach(name => {
                this.userViewForm[name] = '';
            });
            this.resetUserRoleQueryForm();
            this.userRoleList = [];
            if (this.currentActionType == 'config') {
                this.resetRoleQueryForm();
                this.roleList = [];
                this.addSelectedRoleIds = [];
                this.delSelectedRoleIds = [];
            }
        },
        deleteUser(row) {
            if (UPMS_USER_TYPE_SYSTEM == row.userType) {
                this.$message.error('系统级用户不能删除!');
            } else {
                let url = PLATFORM_API.of(
                    '/api/platform/upms/user/delete/' + row.userId
                );
                this.$confirm('您确定要删除该用户?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http
                        .delete(url)
                        .then(response => {
                            let result = response.data;
                            if (result.success) {
                                this.$message.success(result.message);
                                this.queryUserList(1000);
                            } else {
                                this.$message.error(result.message);
                            }
                        })
                        .catch(defaultApiErrorHandler);
                });
            }
        },
        changeUserStatus(row) {
            row.status = row.status == 0 ? 1 : 0; //取消因点击导致的Switch状态变化(Switch的状态由请求结果决定)
            if (UPMS_USER_TYPE_SYSTEM == row.userType) {
                this.$message.error('系统级用户禁止此操作!');
            } else {
                this.$confirm(
                    `您确定要${this.getUserStatusTagName(
                        row.status == 0 ? 1 : 0
                    )}该用户吗?`,
                    '提示',
                    {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }
                ).then(() => {
                    this.submitChangeUserStatus(row);
                });
            }
        },
        submitChangeUserStatus(row) {
            let targetStatus = row.status == 1 ? 0 : 1;
            let url = '';
            if (targetStatus == 1) {
                url = PLATFORM_API.of(
                    '/api/platform/upms/user/enable/' + row.userId
                );
            } else {
                url = PLATFORM_API.of(
                    '/api/platform/upms/user/disable/' + row.userId
                );
            }
            this.$http
                .put(url)
                .then(response => {
                    let result = response.data;
                    if (result.success) {
                        row.confirmStatusVisible = false; //关闭popover
                        row.status = targetStatus;
                        this.$message.success(result.message);
                    } else {
                        this.$message.error(result.message);
                    }
                })
                .catch(defaultApiErrorHandler);
        },
        changeOnlineStatus(event, row) {
            row.online = !row.online; //取消因点击导致的Switch状态变化(Switch的状态由请求结果决定)
            if (row.online) {
                if (UPMS_USER_TYPE_SYSTEM == row.userType) {
                    this.$message.error('系统级用户禁止此操作!');
                } else {
                    row.confirmOffloneVisible = true; //显示popover
                }
            }
            event.preventDefault();
            return false;
        },
        submitChangeOnlineStatus(event, row) {
            if (row.online) {
                //如果当前在线
                let url = PLATFORM_API.of(
                    '/api/platform/upms/user/' + row.userId + '/offline'
                );
                this.$http
                    .post(url)
                    .then(response => {
                        let result = response.data;
                        if (result.success) {
                            row.confirmOffloneVisible = false; //关闭popover
                            row.online = false;
                            this.$message.success(result.message);
                        } else {
                            this.$message.error(result.message);
                        }
                    })
                    .catch(defaultApiErrorHandler);
            }
        },
        openChangeUserPwdDialog(cmd, row) {
            this.currentActionType = cmd;
            this.changeUserPwdDialogVisible = true;
            Vue.nextTick(() => {
                this.changeUserPwdForm.userId = row.userId;
                this.changeUserPwdForm.userName = row.userName;
            });
        },
        closeChangeUserPwdDialog() {
            this.changeUserPwdDialogVisible = false;
            this.$refs.changeUserPwdForm.resetFields();
        },
        changeUserPassword() {
            let url = PLATFORM_API.of('/api/platform/upms/user/changepwd');
            this.$refs.changeUserPwdForm.validate(valid => {
                if (valid && !this.submiting) {
                    this.$confirm('您确定要修改该用户的密码?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.submiting = true;
                        setTimeout(() => {
                            this.$http
                                .put(url, this.changeUserPwdForm)
                                .then(response => {
                                    this.submiting = false;
                                    let result = response.data;
                                    if (result.success) {
                                        this.closeChangeUserPwdDialog();
                                        this.$message.success(result.message);
                                    } else {
                                        this.$message.error(result.message);
                                    }
                                })
                                .catch(defaultApiErrorHandler)
                                .then(() => {
                                    this.submiting = false;
                                });
                        }, 1500);
                    });
                } else {
                    return false;
                }
            });
        },
        saveUser() {
            let url = '';
            let method = 'post';
            if (this.currentActionType == 'add') {
                url = PLATFORM_API.of('/api/platform/upms/user/create');
                method = 'post';
            } else if (this.currentActionType == 'edit') {
                url = PLATFORM_API.of('/api/platform/upms/user/update');
                method = 'put';
            }
            if (url) {
                this.$refs.userEditForm.validate(valid => {
                    if (valid && !this.submiting) {
                        this.submiting = true;
                        setTimeout(() => {
                            this.$http[method](url, this.userEditForm)
                                .then(response => {
                                    let result = response.data;
                                    if (result.success) {
                                        this.closeUserEditDialog();
                                        this.$message.success(result.message);
                                        this.queryUserList(1000);
                                    } else {
                                        this.$message.error(result.message);
                                    }
                                })
                                .catch(defaultApiErrorHandler)
                                .then(() => {
                                    this.submiting = false;
                                });
                        }, 1500);
                    } else {
                        return false;
                    }
                });
            }
        },
        beforeUserIconUpload(file) {
            let fileType = file.type;
            if (IMAGE_TYPES.indexOf(fileType) == -1) {
                this.$message.error('上传图片只能是jpg、png格式!');
                return false;
            }
            if (file.size > 0 && file.size / 1024 > 50) {
                this.$message.error('上传图片大小不能超过50KB!');
                return false;
            }
            return true;
        },
        handleUserIconUploadSuccess(response, file, fileList) {
            file.url = response.data.url;
            file.path = response.data.path;
            this.userEditForm.userIcon = response.data.path;
            this.userEditForm.userIconUrl = response.data.url;
        },
        handleUserIconRemove(file, fileList) {
            if (file && file.path) {
                this.$http.get(
                    PLATFORM_API.of(
                        '/api/xupload/public/remove?path=' + file.path
                    )
                );
            }
        },
        handleUploadError(error, file, fileList) {
            try {
                let result = JSON.parse(error.message);
                this.$message.error(result.message);
            } catch (e) {
                console.error(e);
            }
        },
        queryUserRoleList(loading) {
            let url = PLATFORM_API.of(
                '/api/platform/upms/user/roles/' + this.userViewForm.userId
            );
            if (loading) {
                this.userRoleQueryLoading = true;
            }
            setTimeout(() => {
                this.$http
                    .get(url, {
                        params: this.userRoleQueryForm
                    })
                    .then(response => {
                        let result = response.data;
                        if (result.success) {
                            this.userRoleList = result.data;
                        } else {
                            this.userRoleList = [];
                        }
                    })
                    .catch(error => {
                        this.userRoleList = [];
                        defaultApiErrorHandler.call(this, error);
                    })
                    .then(() => {
                        if (loading) {
                            this.userRoleQueryLoading = false;
                        }
                    });
            }, loading);
        },
        resetUserRoleQueryForm() {
            this.$refs.userRoleQueryForm.resetFields();
        },
        addUserRoleConfig() {
            if (this.addSelectedRoleIds.length) {
                let userId = this.userViewForm.userId;
                let url = PLATFORM_API.of('/api/platform/upms/user/roles/add');
                if (!this.submiting) {
                    this.submiting = true;
                    setTimeout(() => {
                        this.$http
                            .post(url, {
                                userId: userId,
                                roleIds: this.addSelectedRoleIds.join(',')
                            })
                            .then(response => {
                                let result = response.data;
                                if (result.success) {
                                    this.$message.success(result.message);
                                    this.userViewConfigActiveTabName =
                                        'userRoleConfig';
                                    Vue.nextTick(() => {
                                        this.resetUserRoleQueryForm();
                                        this.queryUserRoleList(1000);
                                        this.$refs.roleTable.clearSelection();
                                    });
                                } else {
                                    this.$message.error(result.message);
                                }
                            })
                            .catch(defaultApiErrorHandler)
                            .then(() => {
                                this.submiting = false;
                            });
                    }, 1500);
                }
            } else {
                this.$message.error('请选择需要添加的角色!');
            }
        },
        delUserRoleConfig() {
            if (this.delSelectedRoleIds.length) {
                this.$confirm('您确定要删除该用户的所选角色?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let data = {
                        userId: this.userViewForm.userId,
                        roleIds: this.delSelectedRoleIds.join(',')
                    };
                    let url = PLATFORM_API.of(
                        '/api/platform/upms/user/roles/del'
                    );
                    if (!this.submiting) {
                        this.submiting = true;
                        setTimeout(() => {
                            this.$http
                                .delete(url, { data })
                                .then(response => {
                                    let result = response.data;
                                    if (result.success) {
                                        this.$message.success(result.message);
                                        this.queryUserRoleList(1000);
                                    } else {
                                        this.$message.error(result.message);
                                    }
                                })
                                .catch(defaultApiErrorHandler)
                                .then(() => {
                                    this.submiting = false;
                                });
                        }, 1500);
                    }
                });
            } else {
                this.$message.error('请选择需要移除的角色!');
            }
        },
        showUserRoleAddTab() {
            this.userViewConfigActiveTabName = 'userRoleAdd';
        },
        onRoleQueryCurrentPageChange(currentPage) {
            this.roleQueryForm.currentPage = currentPage;
            this.doQueryRoleList(1000);
        },
        queryRoleList(loading) {
            this.roleQueryForm.currentPage = 1;
            this.doQueryRoleList(loading);
        },
        doQueryRoleList(loading) {
            this.roleQuering = true;
            let url = PLATFORM_API.of('/api/platform/upms/role/list');
            if (loading) {
                this.roleQueryLoading = true;
            }
            setTimeout(() => {
                let params = this.roleQueryForm;
                this.$http
                    .get(url, {
                        params: params
                    })
                    .then(response => {
                        let result = response.data;
                        if (result.success) {
                            this.roleList = result.data;
                            this.roleQueryTotal = result.totalRowCount;
                        } else {
                            this.roleList = [];
                            this.roleQueryTotal = 0;
                        }
                    })
                    .catch(error => {
                        this.roleList = [];
                        this.roleQueryTotal = 0;
                        defaultApiErrorHandler.call(this, error);
                    })
                    .then(() => {
                        if (loading) {
                            this.roleQueryLoading = false;
                        }
                        this.roleQuering = false;
                    });
            }, loading);
        },
        resetRoleQueryForm() {
            this.$refs.roleQueryForm.resetFields();
        },
        onUserRoleSelectionChange(selectedRows) {
            if (selectedRows && selectedRows.length) {
                this.delSelectedRoleIds = [];
                selectedRows.forEach(row => {
                    this.delSelectedRoleIds.push(row.roleId);
                });
            } else {
                this.delSelectedRoleIds = [];
            }
        },
        onRoleSelectionChange(selectedRows) {
            if (selectedRows && selectedRows.length) {
                this.addSelectedRoleIds = [];
                selectedRows.forEach(row => {
                    this.addSelectedRoleIds.push(row.roleId);
                });
            } else {
                this.addSelectedRoleIds = [];
            }
        },
        resetOrgSelectFilterQuery() {
            this.orgSelectFilterQuery = '';
        }
    }
};
</script>
<style lang="scss">
.el-table-maxheight-fix.loading {
    max-height: 320px !important;
    .el-table__body-wrapper {
        max-height: 320px !important;
    }
}
.user-card {
    display: block;
    position: relative;
    height: 40px;
    line-height: 40px;
    padding-left: 45px;

    img {
        display: block;
        border: 0 none;
        margin: 0;
        padding: 0;
        position: absolute;
        left: 0;
        top: 0;
        height: 40px;
        width: 40px;
        border-radius: 50%;
    }
    span {
        line-height: 1;
        display: inline-block;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
    }
}
.el-form-detail .user-card {
    position: absolute;
    bottom: 4px;
}
.user-avatar {
    width: 90px;
    height: 90px;
    display: block;
    margin: 5px;
}
.org-select-option {
    .option-left {
        float: left;
        color: $--color-primary;
        font-size: 13px;
    }
    .option-right {
        float: right;
    }
}
</style>
